module.exports = __webpack_public_path__ + "static/media/IMG_1274.195d3c3b.jpg";